import { OSS_BASE_URL } from '@/constants'
import { AwaitStoreImageSize, From } from '@/data/constant'
import { PartType } from '@/partTypes'
import { calculateImageDisplaySize } from '@/util/plankCommonFuncs'
import { getPlankImage } from '@/views/newPaiban/component/m-paiban-store/utlis'
import { base64ToFile } from '@/views/newPaiban/component/m-paiban-store/utlis'
import { uploadFileToOss } from '@yige/utils'
import { nanoid } from 'nanoid'

const defaultScale = 6

export interface BujianQueryParams {
  colorTextureThickStr?: string
  filterWord?: string
  pageScope?: 'paiban' | 'jinxi'
}

export function getBujianItemKey(item: any) {
  const key =
    item?.bujianItemKey ??
    item?.id ??
    item?._bujianStoreId ??
    item?.partUniqueId ??
    item?.plank?.partUniqueId ??
    ''
  return String(key)
}

export function buildBujianQueryKey(params: BujianQueryParams = {}) {
  const { colorTextureThickStr = '', filterWord = '' } = params
  // 查询 key 只表达“查什么”，不表达“从哪个页面来”，这样普通排版和精细排版可以复用缓存。
  const normalizedColorTextureThickStr = Array.from(
    new Set(
      colorTextureThickStr
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean)
    )
  )
    .sort()
    .join(',')
  return JSON.stringify({
    colorTextureThickStr: normalizedColorTextureThickStr,
    filterWord,
  })
}

export function filterVisibleBujianList(
  list: any[] = [],
  participationIds: string[] = []
) {
  const participationIdSet = new Set(
    participationIds.map((item) => String(item))
  )
  return list.filter((item) => {
    const key = getBujianItemKey(item)
    if (!key) return false
    return !participationIdSet.has(key)
  })
}

export function getBujianParticipationIdsFromPaibanData(
  paibanData: any[] = []
) {
  const result = new Set<string>()
  paibanData.forEach((bigPlank) => {
    // 补件是否“已参与排版”只认落板后的业务标记，避免把普通待排版库板件误计入补件集合。
    ;(bigPlank?.parts ?? []).forEach((part: any) => {
      if (part?._isBujian && part?._bujianStoreId) {
        result.add(String(part._bujianStoreId))
      }
    })
  })

  return Array.from(result)
}

export async function dealBatchBujian(part: PartType, plankUrl: string) {
  const {
    address,
    matCode,
    plankID,
    plankNum,
    texture,
    customer_name,
    oRect,
    thick,
    is_high_gloss_plank,
    orderId,
    orderNo,
  } = part

  const title = `${thick}${matCode}(${texture})`
  const imgUrl = getPlankImage(part, false, {
    defaultScale,
    scale: 3,
    plankLineWidth: 1,
  })
  let plankImageUrl = ''
  let imageSize = {
    width: AwaitStoreImageSize.width + 'px',
    height: AwaitStoreImageSize.height + 'px',
  }
  if (imgUrl) {
    // 获取图片的高度宽度
    const imageSizeResult = await calculateImageDisplaySize(imgUrl)
    if (imageSizeResult) {
      imageSize = {
        width: imageSizeResult.width!,
        height: imageSizeResult.height!,
      }
    }
    const imageFile = base64ToFile(imgUrl, 'plank.png')
    const ossBaseUrl = OSS_BASE_URL + '/' + 'bujian_store'
    // 板件图片oss链接
    plankImageUrl = await uploadFileToOss(
      imageFile,
      () => ({}),
      undefined,
      ossBaseUrl,
      true
    )
  }

  const plateInfo = {
    address,
    color: texture,
    plKId: plankID,
    plankNum,
    partUniqueId: nanoid(),
    new: true,
    from: From.BLUEN,
    customer_name: customer_name || '',
    size: `${oRect.height}*${oRect.width}*${thick}`,
    width: imageSize?.width,
    height: imageSize?.height,
    matCode,
    isShow: true,
    title,
    thick,
    orderId,
    // 高光板标识
    isHighlightMatCode: is_high_gloss_plank,
    is_high_gloss_plank,
    // 必须存一个原始的板件数据的partUniqueIdm, 批量补件中，需要通过这个id找到原始的板件数据
    oriPartUniqueId: part.partUniqueId,
  }
  return {
    plate_info: plateInfo,
    img_url: plankImageUrl,
    oid: part.orderId,
    // 接口字段为 order_no，补件列表展示「订单号」依赖该字段
    order_no: orderNo || '',
    render_url: plankUrl,
  }
}
